import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiDiasTaller, ApiHorasTaller } from '../models/ApiHorasTaller';

@Injectable({
  providedIn: 'root'
})
/*
  ACTUALMENTE EN DESUSO ya que el compenent de Agenda esta en  desuso
*/
export class ApiService
{
  private apiUrl = 'https://api.example.com/data';
  private httpOptions =
  {
    headers: new HttpHeaders
    ({
      'Content-Type':  'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  //Recupera las horas o dias del taller
  public getHorasTaller(delegacion:number,dia:string):Promise<ApiHorasTaller>
  {
    let url:string = environment.wsDisponibilidadHorasURL;
    let params = environment.wsDisponibilidadHorasParams;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Authorization', 'Bearer ' + params.token)
    };

    params.delegacion=delegacion;
    params.tipo=1;
    params.dia=dia;

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,params,httpOptions)
      .subscribe
      ({
        next(response)
        {
          resolve(response);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }
  //recog las fechas de los dias en los que NO se puede pedir cita en ese taller
  public getDiasFestivosTaller(delegacion:number,dia:string,):Promise<ApiDiasTaller>
  {
    let url:string = environment.wsDisponibilidadHorasURL;
    let params = environment.wsDisponibilidadHorasParams;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Authorization', 'Bearer ' + params.token),
      params: new HttpParams({})
    };

    params.delegacion=delegacion;
    params.tipo=0;
    params.dia=dia;

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,params,httpOptions)
      .subscribe
      ({
        next(value)
        {
          resolve(value);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      });
    });
  }

  public callBuscador(txtBastidor: string, txtMatricula: string, usuario: string, usarAudatext: boolean){
    let cuerpo = '';
    let url= "https://workshops.ralarsa.com/ssl/wsRalarsa/acierta/search";
    //let url= "google.com";
    let token: string = "I4mCBmV!!ODRslk0U0VAsAZZELjLpBEcICyf3fiQYKK9Mf";
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    if (txtBastidor.trim() !== '') {
      cuerpo = `token=${token}&tipo=vin&etiqueta=contact${usuario}&vin=${txtBastidor.trim()}&usuario=${usuario}&delegacion=970&option_cristal=Front&usar_audatext=${usarAudatext}&matricula=`;
    } else {
      cuerpo = `token=${token}&tipo=matricula&etiqueta=contact${usuario}&vin=&usuario=${usuario}&delegacion=970&option_cristal=Front&usar_audatext=${usarAudatext}&matricula=${txtMatricula}`;
    }

    return this.http.post(url, cuerpo, { headers: headers, responseType: 'json' });

  }

  public callDgt(txtMatricula: string){
    let cuerpo = '';
    let url= `https://workshops.ralarsa.com/nou/ralarsa/webservice/webservicedgtpeticiones/busquedaDgt.php?matricula=${txtMatricula}`;
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(url, {responseType: 'text' });

  }
}
